import React from 'react';
import { Link } from 'gatsby';
import {
  Image,
} from '../common';
import { getExcerpt } from '../../util/helpers';
import './PostListItem.scss';

const PostListItem = (props) => {
  const {
    uid,
    data,
    blogSlug,
  } = props;
  const {
    postTitle,
    featuredImage,
    metaDescription,
  } = data;
  return (
    <div className="post-list-item">
      <Link
        className="container"
        to={`/${blogSlug}/${uid}/`}
        aria-label={`Read more about ${postTitle.text}`}
      >
        <div className="image-container">
          <Image image={featuredImage} />
        </div>
        <div className="text-container">
          <h3 className="title">{postTitle.text}</h3>
          <p className="excerpt">{getExcerpt(metaDescription.text, 50)}</p>
        </div>
      </Link>
    </div>
  );
};

export default PostListItem;
